module.exports = ".hero{margin-bottom:2rem;box-shadow:0 30px 40px 0 rgba(0,0,0,0.11)}\n"